export default __webpack_public_path__ + "static/course-modal-3cca40e673158c497c3e253a8cf80b86.jpg";